import { PersonalInfo, Project } from '../types/portfolio';

export const personalInfo: PersonalInfo = {
  name: "William Brunton",
  title: "Computer Systems Engineer",
  bio: "",
  education: [
    "BE(Hons) Computer Systems Engineering, University of Auckland",
    "First Class Honours (Graduating May)"
  ],
  skills: [
    "C/C++",
    "Java",
    "Python",
    "Rust",
    "Assembly"
  ],
  contact: {
    github: "https://github.com/KBD2",
    linkedin: "https://www.linkedin.com/in/william-brunton-7049aa17b/"
  }
};

export const projects: Project[] = [
  {
    id: "rustos",
    title: "RustOS",
    description: "Part 4 Engineering project – hard real-time operating system written in Rust, targeting the FlexPRET processor architecture. Won the Embedded Systems industry award at end-of-year prizegiving.",
    image: "/images/rustos.png",
    links: [
      { label: "GitHub", url: "https://github.com/lthw148/rustos" }
    ],
    technologies: ["Rust", "RISC-V Assembly", "RTOS"]
  },
  {
    id: "terrario",
    title: "Terrario",
    description: "Recreation of the popular video game Terraria for the Casio fx-9750GII graphing calculator, written in the C programming language. Won the 2021 Planet Casio \"Most Ambitious C Program\" award.",
    image: "/images/terrario.png",
    links: [
      { label: "GitHub", url: "https://github.com/KBD2/terrario" },
      {label: "Planet Casio", url: "https://www.planet-casio.com/Fr/forums/topic16373-1-terrario-a-terraria-rewrite-for-the-calculator.html"}
    ],
    technologies: ["C", "Embedded"]
  },
  {
    id: "schemtovox",
    title: "SchemToVox",
    description: "Python tool for converting Minecraft schematics to MagicaVoxel voxel shapes.",
    image: "/images/schemtovox.png",
    links: [{label:"GitHub",url:"https://github.com/KBD2/SchemToVox"}],
    technologies: ["Python"]
  },
  {
    id: "beantracer",
    title: "BeanTracer",
    description: "Raytracer written in Java. Supports many different materials, textures, and mediums. Configurable via JSON.",
    image: "/images/beantracer.png",
    links: [{label:"GitHub",url:"https://github.com/KBD2/BeanTracer"}],
    technologies: ["Java", "Raytracing"]
  }
];
